import React, { Component } from 'react';
import { Button, translate } from 'react-admin';

const DownloadButton = ({ record }) => (
    <Button
        label='resources.reports.fields.download'
        href={record.url}
        disabled={record.url == null}
    />
);

export default translate(DownloadButton);